import { nameFileWithoutPath } from "../Utils/functionService";
import { axiosWithToken, axiosWithTokenForBlob } from "./axiosService";

export const isValidToken = async ( token: string ) => {
    try {
        const response = await axiosWithToken().post(`api/workingFolder/checkToken?token=${token}`);
        return response
    } catch (error) {
        throw error;
    }
};

export const getFileData = async ( token: string, password: string ) => {
    try {
        const response = await axiosWithToken().get(`api/workingFolder?token=${token}&password=${password}`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getFile = async (token: string, password: string, fileName: string, onDownloadProgress: (progressEvent: any) => void) => {
    try {
      const response = await axiosWithTokenForBlob().get(
        `api/workingFolder/zip?token=${token}&password=${password}`,
        {
          responseType: 'arraybuffer', onDownloadProgress
        });
        if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', fileName);
        document.body.appendChild(link)
        link.click();
        document.body.removeChild(link);
        return response.data
      } else {
        console.error(`Error: Received status code ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  };